// TODO: Remove this temporary compatibility layer after all consumers are
// migrated from the old Reactstrap API to native React-Bootstrap components.
// This file exists only to keep the React 19 migration small and safe while
// we still have many imports using Reactstrap-style names and props.

import PropTypes from 'prop-types';
import {
  Button as BootstrapButton,
  Card as BootstrapCard,
  Dropdown as BootstrapDropdown,
  Modal as BootstrapModal,
} from 'react-bootstrap';

const Button = ({ color = 'secondary', ...props }) => (
  <BootstrapButton variant={color} {...props} />
);

Button.propTypes = {
  color: PropTypes.string,
};

const ButtonDropdown = ({ isOpen = false, toggle, ...props }) => {
  const handleToggle = (nextIsOpen) => {
    if (nextIsOpen !== isOpen) {
      toggle?.();
    }
  };

  return <BootstrapDropdown show={isOpen} onToggle={handleToggle} {...props} />;
};

ButtonDropdown.propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
};

const DropdownToggle = ({
  caret = false,
  className,
  color = 'secondary',
  style,
  ...props
}) => (
  <BootstrapDropdown.Toggle
    bsPrefix={caret ? 'dropdown-toggle' : 'reactstrap-dropdown-toggle'}
    className={className}
    variant={color}
    style={{ position: 'relative', ...style }}
    {...props}
  />
);

DropdownToggle.propTypes = {
  caret: PropTypes.bool,
  className: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object,
};

const Modal = ({
  isOpen = false,
  toggle,
  className,
  fade = true,
  ...props
}) => (
  <BootstrapModal
    show={isOpen}
    onHide={toggle}
    dialogClassName={className}
    animation={fade}
    {...props}
  />
);

Modal.propTypes = {
  className: PropTypes.string,
  fade: PropTypes.bool,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
};

const ModalHeader = ({ children, toggle, ...props }) => (
  <BootstrapModal.Header closeButton={Boolean(toggle)} {...props}>
    <BootstrapModal.Title>{children}</BootstrapModal.Title>
  </BootstrapModal.Header>
);

ModalHeader.propTypes = {
  children: PropTypes.node,
  toggle: PropTypes.func,
};

const Card = BootstrapCard;
const CardBody = BootstrapCard.Body;
const CardFooter = BootstrapCard.Footer;
const CardHeader = BootstrapCard.Header;
const DropdownItem = BootstrapDropdown.Item;
const DropdownMenu = BootstrapDropdown.Menu;
const ModalBody = BootstrapModal.Body;
const ModalFooter = BootstrapModal.Footer;

export {
  Button,
  ButtonDropdown,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
};

export default Card;
